import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import Swal from "sweetalert2";

function Transfer() {
  const [receiverAddress, setReceiverAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accounts, setAccounts] = useState([]);

 useEffect(() => {
    async function loadAccounts() {
      if (!window.ethereum) {
        Swal.fire("Metamask not detected.", "Please install Metamask.", "info");
        return;
      }

      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const accounts = await provider.listAccounts();
        setAccounts(accounts);
        setSelectedAccount(accounts[0]); // Set the first account as the default selected account
      } catch (error) {
        Swal.fire("Error!!", `Error: ${error.message}`, "error");
      }
    }

    loadAccounts();
  }, []);


  async function transferETH() {
    if (!selectedAccount) {
          alert("");
          Swal.fire("Warning!!", "Please select an Ethereum account from MetaMask.", "warning");
          return;
        }

        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner(selectedAccount);

          const tx = await signer.sendTransaction({
            to: receiverAddress,
            value: ethers.utils.parseEther(amount),
          })
          Swal.fire('Success!', `The transaction has been submitted successfully. Please wait for confirmation on your wallet. Transaction sent: ${tx.hash}`, 'success');
        } catch (error) {
          Swal.fire("Error!!", `Error: ${error.message}`, "error");
        }
      }


    return (
      <Container>
      <Card border='info'>
        <Card.Header style={{ backgroundColor:'midnightblue', color:'yellow'}}>Pindah Dana Akaun</Card.Header>
        <Card.Body>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon3">
              Pilih Akaun
            </InputGroup.Text>
            <Form.Select value={selectedAccount} onChange={(e) => setSelectedAccount(e.target.value)}>
              {accounts.map((account) => (
                <option key={account} value={account}>
                  {account}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon2">
              Ke Akaun
              </InputGroup.Text>
              <Form.Control id="basic-url" aria-describedby="basic-addon2" value={receiverAddress}
          onChange={(e) => setReceiverAddress(e.target.value)} />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">
              Jumlah Pindahan
              </InputGroup.Text>
              <Form.Control id="basic-url" aria-describedby="basic-addon1" value={amount}
          onChange={(e) => setAmount(e.target.value)} />
              <InputGroup.Text id='basic-addon1'>SepoliaETH</InputGroup.Text>
              </InputGroup>
          <Button variant='primary' onClick={transferETH}>Pindah</Button>
        </Card.Body>
      </Card>
      </Container>
    );
  };
  
export default Transfer;